import { createContext, useContext, useState } from 'react';

const Context = createContext({});

export function ToastProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('info');

  function showToast(message, variant) {
    setOpen(true);
    setMessage(message);
    setVariant(variant);
  }

  function closeToast() {
    setOpen(false);
    setMessage('');
  }

  return (
    <Context.Provider value={{ open, message, variant, closeToast, showToast }}>
      {children}
    </Context.Provider>
  );
}

export function useToastContext() {
  return useContext(Context);
}
